import type { InjectionKey, Ref } from 'vue';
import type { ILawyerDetail } from '@/entities/lawyer/model/types/lawyer';

export const LAWYER_INFO: InjectionKey<Ref<ILawyerDetail | null>> =
  Symbol.for('lawyer.lawyerInfo');
